import { Briefcase } from 'lucide-react';

import { definePanel } from '@/app/definePanel';
import { BookmarkIcon } from '@/components/occurra/icons/BookmarkIcon';
import { BookmarksTab } from '@/types/bookmarks';
import { PanelMode, PanelTheme } from '@/types/panels';

export default definePanel({
    id: 'bookmarks',
    title: 'Bookmarks',
    description: 'The moments somebody marked, and the cases that collect them.',
    icon: BookmarkIcon,
    launcherTabs: [
        {
            key: BookmarksTab.Bookmarks,
            label: 'Bookmarks',
            description: 'The moments somebody marked to find them again.',
            icon: BookmarkIcon,
            props: { bookmarksTab: BookmarksTab.Bookmarks },
        },
        {
            key: BookmarksTab.Cases,
            label: 'Cases',
            description: 'The investigations: their videos, descriptions and attachments.',
            icon: Briefcase,
            props: { bookmarksTab: BookmarksTab.Cases },
            // Only an administrator works the cases.
            requiresAdmin: true,
        },
    ],
    width: { min: 420, default: 480, max: Infinity, fill: false },
    modes: [PanelMode.View],
    themes: PanelTheme.Any,
    // Last in the nav's view half.
    order: 4.7,
    // The panel draws its header itself: the Bookmarks and Cases tabs.
    isHeaderless: true,
    // Scope the list to the camera selected elsewhere in the shell (cameras
    // panel, camera_view). Empty shows every camera's bookmarks.
    urlSyncedProps: ['cameraId'],
});
